import { ContingentViewSchema } from '@fsf/types';
import { _ } from '@ngx-translate/core';
import { z } from 'zod';

export type Contingent = z.infer<typeof ContingentViewSchema>;

export const StoreContingentSchema = z
  .object({
    title: z.string().min(1, { message: 'validation.required' }).max(255),
    description: z.string().nullable().optional(),
    total_amount: z
      .number()
      .int()
      .min(0, { message: _('validation.minZero') }),
    instruction_amount: z
      .number()
      .int()
      .min(0, { message: _('validation.minZero') }),
  })
  .superRefine((value, ctx) => {
    if (value.instruction_amount > value.total_amount) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['instruction_amount'],
        message: 'validation.instructionExceedsTotal',
      });
    }
  });

export type StoreContingentPayload = z.infer<typeof StoreContingentSchema>;

export const UpdateContingentSchema = StoreContingentSchema;
export type UpdateContingentPayload = z.infer<typeof UpdateContingentSchema>;

export const contingentTranslations = _([
  'catalog.contingents.title',
  'catalog.contingents.add',
  'catalog.contingents.edit',
  'catalog.contingents.deleteConfirmHeader',
  'catalog.contingents.deleteConfirmMessage',
  'catalog.contingents.created',
  'catalog.contingents.updated',
  'catalog.contingents.deleted',
  'catalog.contingents.loadError',
  'catalog.contingents.createError',
  'catalog.contingents.updateError',
  'catalog.contingents.deleteError',
  'catalog.contingents.blockedByCategoriesHeader',
  'catalog.contingents.blockedByCategoriesMessage',
  'catalog.contingents.fields.title',
  'catalog.contingents.fields.description',
  'catalog.contingents.fields.totalAmount',
  'catalog.contingents.fields.instructionAmount',
  'catalog.contingents.dashboardDescription',
  'catalog.contingents.dashboardButton',
]);
